import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Trash2 } from "react-feather";
import { Button } from "semantic-ui-react";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  boxShadow: 24,
  borderRadius: "12px",
  outline: "none",
  overflow: "hidden",
  maxWidth: "90vw",
  width: "420px",
  padding: "24px",
};

export default function RemovePictureConfirmModal({
  open,
  onClose,
  onConfirm,
  isRemoving,
}) {
  return (
    <Modal
      open={open}
      onClose={isRemoving ? undefined : onClose}
      aria-labelledby="remove-modal-title"
    >
      <Box sx={modalStyle}>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "#fee2e2",
              color: "#dc2626",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <Trash2 size={24} />
          </div>

          <h3
            style={{
              margin: "0 0 8px",
              fontSize: "18px",
              fontWeight: "600",
              color: "#111827",
            }}
          >
            Remove profile picture?
          </h3>

          <p
            style={{
              margin: "0 0 24px",
              fontSize: "14px",
              color: "#4b5563",
              lineHeight: "1.5",
            }}
          >
            Your current profile picture will be removed and replaced with your
            default initials avatar across the platform.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <Button
              type="button"
              onClick={onClose}
              disabled={isRemoving}
              style={{
                borderRadius: "6px",
                minWidth: "90px",
              }}
            >
              Cancel
            </Button>
            <Button
              type="button"
              color="red"
              onClick={onConfirm}
              loading={isRemoving}
              disabled={isRemoving}
              style={{
                borderRadius: "6px",
                minWidth: "110px",
                backgroundColor: "#dc2626",
              }}
            >
              Remove
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
